import { BondRequestPreview } from "@portal/api/bond-request/agent";
import { useFetchBondRequestPreviews } from "@portal/api/previews";
import { DynamicDataTable } from "@portal/components/ui/DynamicDataTable/DynamicDataTable";
import { useIsMinimalBondUIEnabled } from "@portal/hooks/useIsMinimalBondUIEnabled";
import { useMemo } from "react";
import type { PreviewTableProps } from "../../shared/layouts/EntityPreviewsLayout";
import { useAdminPreviewsTable } from "../shared/useAdminPreviewsTable";
import { getRequestsTableColumns } from "./columns";

const getRowHref = (row: BondRequestPreview) => `/accounts/${row.accountId}/requests/${row.id}`;

type BondRequestFilter = (request: BondRequestPreview) => boolean;

export const createAdminBondRequestPreviews = (
	tableName: string,
	filterPredicate?: BondRequestFilter,
) => {
	const AdminBondRequestPreviews = ({ scope }: Pick<PreviewTableProps, "scope">) => {
		const { bondRequestPreviews } = useFetchBondRequestPreviews();
		const { data, defaultColumnFilters, scopeColumnFilters } = useAdminPreviewsTable({
			data: bondRequestPreviews,
			filterPredicate,
			scope,
		});
		const isMinimalUIEnabled = useIsMinimalBondUIEnabled();
		const columns = useMemo(
			() => getRequestsTableColumns(isMinimalUIEnabled),
			[isMinimalUIEnabled],
		);

		return (
			<DynamicDataTable
				name={tableName}
				columns={columns}
				getRowHref={getRowHref}
				data={data}
				defaultColumnFilters={defaultColumnFilters}
				enforcedColumnFilters={scopeColumnFilters}
				loadingMessage="Loading bond requests..."
				enableExportToCSV
			/>
		);
	};

	return AdminBondRequestPreviews;
};
